import axios from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    shipping: null,
    shippings: [],
    shippingContext: null,
  },

  getters: {
    shipping(state) {
      return state.shipping
    },
    shippings(state) {
      return state.shippings
    },
    shippingContext(state) {
      return state.shippingContext
    },
  },

  mutations: {
    SET_SHIPPING(state, value) {
      state.shipping = value
    },
    SET_SHIPPINGS(state, value) {
      state.shippings = value
    },
    SET_SHIPPING_CONTEXT(state, value) {
      state.shippingContext = value
    },
    REMOVE_SHIPPING(state, id) {
      state.shippings = state.shippings.filter((item) => item.id !== id)
    },
  },

  actions: {
    loadBySale({ commit }, saleId) {
      return axios.get(`api/sales/${saleId}/shippings`).then((response) => {
        const data = response.data.data ?? response.data
        commit('SET_SHIPPINGS', data)
        return data
      })
    },
    loadShippingContext({ commit }, { saleId, excludeShippingId = null }) {
      const params = excludeShippingId ? { exclude_shipping_id: excludeShippingId } : {}
      return axios.get(`api/sales/${saleId}/shipping-context`, { params }).then((response) => {
        const data = response.data.data ?? response.data
        commit('SET_SHIPPING_CONTEXT', data)
        return data
      })
    },
    loadShipping({ commit }, shippingId) {
      return axios.get(`api/shippings/${shippingId}`).then((response) => {
        const data = response.data.data ?? response.data
        commit('SET_SHIPPING', data)
        return data
      })
    },
    createShipping(_, { saleId, payload }) {
      return axios.post(`api/sales/${saleId}/shippings`, payload).then((response) => {
        return response.data.data ?? response.data
      })
    },
    updateShipping(_, { id, payload }) {
      return axios.put(`api/shippings/${id}`, payload).then((response) => {
        return response.data.data ?? response.data
      })
    },
    deleteShipping({ commit }, id) {
      return axios.delete(`api/shippings/${id}`).then((response) => {
        commit('REMOVE_SHIPPING', id)
        return response.data
      })
    },
  },
}
